import _ from 'lodash';
import {
	FieldConfiguration,
	ProductConfigurationResponse,
} from '../../api/ConfigApi';

export function checkCanRunReport(reportName: string, req: any) {
	switch (reportName) {
		case 'All Policies Report':
			return (
				req.reportStartTimestamp &&
				req.reportEndTimestamp &&
				req.productNames.length
			);
		case 'Claims Payable Report':
			return req.endTimestamp && req.startTimestamp;
		case 'Claims Report':
			return req.reportTimestamp;
		case 'Claims Reserves Report':
			return req.reportTimestamp;
		case 'Financial Transactions Report':
			return req.endTimestamp && req.startTimestamp;
		case 'On-Risk Report':
			return req.reportTimestamp && req.productNames.length;
		case 'Paid Financial Transactions Report':
			return req.endTimestamp && req.startTimestamp;
		case 'Payable Commissions Report':
			return req.endTimestamp && req.startTimestamp;
		case 'Unearned Premium (A/R) Report':
			return req.reportTimestamp;
	}
}

export function getPolicyReportReq(
	req: any,
	configs: ProductConfigurationResponse[],
) {
	return {
		...req,
		policyFields: _.uniq(getPolicyFields(req.productNames, configs)),
		exposureFields: _.uniq(getExposureFields(req.productNames, configs)),
		perilFields: _.uniq(getPerilFields(req.productNames, configs)),
	};
}

export function getPolicyFields(
	productNames: string[],
	configs: ProductConfigurationResponse[],
) {
	let fieldNames: string[] = [];
	productNames.forEach((product) => {
		const config = configs.find((c) => c.name === product);
		fieldNames = fieldNames.concat(
			getFieldNames(getValidReportFields(config.policyConfiguration.fields)),
		);
	});
	return fieldNames;
}

export function getExposureFields(
	productNames: string[],
	configs: ProductConfigurationResponse[],
) {
	let fieldNames: string[] = [];
	productNames.forEach((product) => {
		const config = configs.find((c) => c.name === product);
		fieldNames = fieldNames.concat(getExposureFieldNames(config));
	});
	return fieldNames;
}

export function getPerilFields(
	productNames: string[],
	configs: ProductConfigurationResponse[],
) {
	let fieldNames: string[] = [];
	productNames.forEach((product) => {
		const config = configs.find((c) => c.name === product);
		fieldNames = fieldNames.concat(getPerilFieldNames(config));
	});
	return fieldNames;
}

export function getExposureFieldNames(config: ProductConfigurationResponse) {
	let exposureFields: string[] = [];
	config.policyConfiguration.exposures.forEach((e) => {
		exposureFields = exposureFields.concat(
			getFieldNames(getValidReportFields(e.fields)),
		);
	});
	return exposureFields;
}

export function getPerilFieldNames(config: ProductConfigurationResponse) {
	let perilFields: string[] = [];
	config.policyConfiguration.exposures.forEach((e) => {
		e.perils.forEach((p) => {
			perilFields = perilFields.concat(
				getFieldNames(getValidReportFields(p.fields)),
			);
		});
	});
	return perilFields;
}

export function getFieldNames(fields: FieldConfiguration[]) {
	return fields.map((f) => f.name);
}

export function getValidReportFields(fields: FieldConfiguration[]) {
	return fields.filter((f) => f.type !== 'media');
}
